export const GET_PROFILES = "view_leaderboard"
export const GET_PROFILES_ERROR = "VIEW_LEADERBOARD_ERROR"